(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[425],{

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 628:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[uid]",
      function () {
        return __webpack_require__(6007);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wx": function() { return /* binding */ components; }
});

// UNUSED EXPORTS: ContactForm, Image, Quote, Text

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/Bounded.js
var Bounded = __webpack_require__(2236);
;// CONCATENATED MODULE: ./slices/components/Field/index.jsx

const Field = (param)=>{
    let { label , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-sm text-slate-500",
                children: label
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./slices/components/Input/index.jsx


const InputField = (param)=>{
    let { label , name , type ="text" , placeholder , required =true  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, {
        label: label,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
            name: name,
            type: type,
            required: required,
            placeholder: placeholder,
            className: "w-full rounded-none border-b border-slate-200 py-3 pr-7 pl-3 text-slate-800 placeholder-slate-400"
        })
    });
};

;// CONCATENATED MODULE: ./slices/components/TextareaField/index.jsx


const TextareaField = (param)=>{
    let { label , name , placeholder , required =true  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, {
        label: label,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
            name: name,
            required: required,
            placeholder: placeholder,
            className: "h-40 w-full rounded-none border-b border-slate-200 py-3 pr-7 pl-3 text-slate-800 placeholder-slate-400"
        })
    });
};

;// CONCATENATED MODULE: ./slices/ContactForm/index.js




const ContactForm = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bounded/* Bounded */.g, {
        as: "section",
        size: "small",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            action: "/api/contact",
            method: "post",
            className: "grid grid-cols-1 gap-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField, {
                    label: "Name",
                    name: "name",
                    placeholder: "Jane Doe"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField, {
                    label: "Email Address",
                    name: "email",
                    type: "email",
                    placeholder: "jane.doe@example.com"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaField, {
                    label: "Message",
                    name: "message",
                    placeholder: "Write your message here…"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "submit",
                    className: "ml-auto inline-flex items-center gap-2",
                    children: [
                        "Send message",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": true,
                            className: "text-xl",
                            children: "→"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var slices_ContactForm = (ContactForm);

// EXTERNAL MODULE: ./node_modules/@prismicio/helpers/dist/index.js
var dist = __webpack_require__(7046);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/index.js
var react_dist = __webpack_require__(4776);
// EXTERNAL MODULE: ./node_modules/@prismicio/next/dist/PrismicNextImage.js + 4 modules
var PrismicNextImage = __webpack_require__(9756);
;// CONCATENATED MODULE: ./slices/Image/index.js





const Image = (param)=>{
    let { slice  } = param;
    const image = slice.primary.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bounded/* Bounded */.g, {
        as: "section",
        size: slice.variation === "wide" ? "widest" : "base",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
            className: "grid grid-cols-1 gap-4",
            children: [
                dist/* isFilled.image */.vd.image(image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-gray-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                        field: image,
                        sizes: "100vw",
                        className: "w-full"
                    })
                }),
                dist/* isFilled.richText */.vd.richText(slice.primary.caption) && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                    className: "text-center font-serif italic tracking-tight text-slate-500 dark:text-[#f5f4f5]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dist/* PrismicRichText */.v, {
                        field: slice.primary.caption
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var slices_Image = (Image);

;// CONCATENATED MODULE: ./slices/Quote/index.js




const Quote = (param)=>{
    let { slice  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bounded/* Bounded */.g, {
        as: "section",
        size: "wide",
        children: dist/* isFilled.richText */.vd.richText(slice.primary.quote) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "font-serif text-3xl italic leading-relaxed dark:text-[#f5f4f5]",
            children: [
                "“",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dist/* PrismicText */.Kv, {
                    field: slice.primary.quote
                }),
                "”",
                dist/* isFilled.keyText */.vd.keyText(slice.primary.source) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        " — ",
                        slice.primary.source
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var slices_Quote = (Quote);

;// CONCATENATED MODULE: ./slices/Text/index.js




const Text = (param)=>{
    let { slice  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bounded/* Bounded */.g, {
        as: "section",
        children: dist/* isFilled.richText */.vd.richText(slice.primary.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "font-serif leading-relaxed dark:text-[#f5f4f5] md:text-xl md:leading-relaxed",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dist/* PrismicRichText */.v, {
                field: slice.primary.text
            })
        })
    });
};
/* harmony default export */ var slices_Text = (Text);

;// CONCATENATED MODULE: ./slices/index.js
// Code generated by Slice Machine. DO NOT EDIT.





const components = {
    contact_form: slices_ContactForm,
    image: slices_Image,
    quote: slices_Quote,
    text: slices_Text
};


/***/ }),

/***/ 6007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _uid_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/index.js
var dist = __webpack_require__(4776);
// EXTERNAL MODULE: ./node_modules/@prismicio/helpers/dist/index.js
var helpers_dist = __webpack_require__(7046);
;// CONCATENATED MODULE: ./node_modules/@upstash/claps/chunk-SOEV5HRE.mjs
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));



// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
;// CONCATENATED MODULE: ./node_modules/@upstash/claps/claps.mjs


// components/claps/claps.tsx




// components/claps/icons.tsx

function Icons() {
  return /* @__PURE__ */ react.createElement("svg", {
    style: { display: "none" },
    version: "2.0"
  }, /* @__PURE__ */ react.createElement("defs", null, /* @__PURE__ */ react.createElement("symbol", {
    id: "icon-claps",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /* @__PURE__ */ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.37.83L12 3.28l.63-2.45h-1.26zM13.92 3.95l1.52-2.1-1.18-.4-.34 2.5zM8.59 1.84l1.52 2.11-.34-2.5-1.18.4zM18.52 18.92a4.23 4.23 0 0 1-2.62 1.33l.41-.37c2.39-2.4 2.86-4.95 1.4-7.63l-.91-1.6-.8-1.67c-.25-.56-.19-.98.21-1.29a.7.7 0 0 1 .55-.13c.28.05.54.23.72.5l2.37 4.16c.97 1.62 1.14 4.23-1.33 6.7zm-11-.44l-4.15-4.15a.83.83 0 0 1 1.17-1.17l2.16 2.16a.37.37 0 0 0 .51-.52l-2.15-2.16L3.6 11.2a.83.83 0 0 1 1.17-1.17l3.43 3.44a.36.36 0 0 0 .52 0 .36.36 0 0 0 0-.52L5.29 9.51l-.97-.97a.83.83 0 0 1 0-1.16.84.84 0 0 1 1.17 0l.97.97 3.44 3.43a.36.36 0 0 0 .51 0 .37.37 0 0 0 0-.52L6.98 7.83a.82.82 0 0 1-.18-.9.82.82 0 0 1 .76-.51c.22 0 .43.09.58.24l5.8 5.79a.37.37 0 0 0 .58-.42L13.4 9.67c-.26-.56-.2-.98.2-1.29a.7.7 0 0 1 .55-.13c.28.05.55.23.73.5l2.2 3.86c1.3 2.38.87 4.59-1.29 6.75a4.65 4.65 0 0 1-4.19 1.37 7.73 7.73 0 0 1-4.07-2.25zm3.23-12.5l2.12 2.11c-.41.5-.47 1.17-.13 1.9l.22.46-3.52-3.53a.81.81 0 0 1-.1-.36c0-.23.09-.43.24-.59a.85.85 0 0 1 1.17 0zm7.36 1.7a1.86 1.86 0 0 0-1.23-.84 1.44 1.44 0 0 0-1.12.27c-.3.24-.5.55-.58.89-.25-.25-.57-.4-.91-.47-.28-.04-.56 0-.82.1l-2.18-2.18a1.56 1.56 0 0 0-2.2 0c-.2.2-.33.44-.4.7a1.56 1.56 0 0 0-2.63.75 1.6 1.6 0 0 0-2.23-.04 1.56 1.56 0 0 0 0 2.2c-.24.1-.5.24-.72.45a1.56 1.56 0 0 0 0 2.2l.52.52a1.56 1.56 0 0 0-.75 2.61L7 19a8.46 8.46 0 0 0 4.48 2.45 5.18 5.18 0 0 0 3.36-.5 4.89 4.89 0 0 0 4.2-1.51c2.75-2.77 2.54-5.74 1.43-7.59L18.1 7.68z"
  })), /* @__PURE__ */ react.createElement("symbol", {
    id: "icon-claps-fill",
    fill: "currentColor"
  }, /* @__PURE__ */ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.37.83L12 3.28l.63-2.45h-1.26zM15.42 1.84l-1.18-.39-.34 2.5 1.52-2.1zM9.76 1.45l-1.19.4 1.53 2.1-.34-2.5zM20.25 11.84l-2.5-4.4a1.42 1.42 0 0 0-.93-.64.96.96 0 0 0-.75.18c-.25.19-.4.42-.45.7l.05.05 2.35 4.13c1.62 2.95 1.1 5.78-1.52 8.4l-.46.41c1-.13 1.93-.6 2.78-1.45 2.7-2.7 2.51-5.59 1.43-7.38zM12.07 9.01c-.13-.69.08-1.3.57-1.77l-2.06-2.07a1.12 1.12 0 0 0-1.56 0c-.15.15-.22.34-.27.53L12.07 9z"
  }), /* @__PURE__ */ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.74 8.3a1.13 1.13 0 0 0-.73-.5.67.67 0 0 0-.53.13c-.15.12-.59.46-.2 1.3l1.18 2.5a.45.45 0 0 1-.23.76.44.44 0 0 1-.48-.25L7.6 6.11a.82.82 0 1 0-1.15 1.15l3.64 3.64a.45.45 0 1 1-.63.63L5.83 7.9 4.8 6.86a.82.82 0 0 0-1.33.9c.04.1.1.18.18.26l1.02 1.03 3.65 3.64a.44.44 0 0 1-.15.73.44.44 0 0 1-.48-.1L4.05 9.68a.82.82 0 0 0-1.4.57.81.81 0 0 0 .24.58l1.53 1.54 2.3 2.28a.45.45 0 0 1-.64.63L3.8 13a.81.81 0 0 0-1.39.57c0 .22.09.43.24.58l4.4 4.4c2.8 2.8 5.5 4.12 8.68.94 2.27-2.28 2.71-4.6 1.34-7.1l-2.32-4.08z"
  })), /* @__PURE__ */ react.createElement("symbol", {
    id: "icon-reply",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /* @__PURE__ */ react.createElement("path", {
    d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
  })), /* @__PURE__ */ react.createElement("symbol", {
    id: "icon-dots",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /* @__PURE__ */ react.createElement("circle", {
    cx: "5",
    cy: "12",
    r: "1"
  }), /* @__PURE__ */ react.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), /* @__PURE__ */ react.createElement("circle", {
    cx: "19",
    cy: "12",
    r: "1"
  })), /* @__PURE__ */ react.createElement("symbol", {
    id: "icon-clipboard",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /* @__PURE__ */ react.createElement("rect", {
    x: "8",
    y: "8",
    width: "12",
    height: "12",
    rx: "2"
  }), /* @__PURE__ */ react.createElement("path", {
    d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  })), /* @__PURE__ */ react.createElement("symbol", {
    id: "icon-twitter",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /* @__PURE__ */ react.createElement("path", {
    d: "M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.522 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c-.002 -.249 1.51 -2.772 1.818 -4.013z"
  })), /* @__PURE__ */ react.createElement("symbol", {
    id: "icon-email",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /* @__PURE__ */ react.createElement("rect", {
    x: "3",
    y: "5",
    width: "18",
    height: "14",
    rx: "2"
  }), /* @__PURE__ */ react.createElement("polyline", {
    points: "3 7 12 13 21 7"
  })), /* @__PURE__ */ react.createElement("symbol", {
    id: "icon-x",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /* @__PURE__ */ react.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), /* @__PURE__ */ react.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }))));
}

// components/claps/share.tsx

function Share({
  onClose = () => {
  }
}) {
  const onAction = (action) => {
    const url = window.location.href;
    if (action === "clipboard") {
      navigator.clipboard.writeText(url);
    } else if (action === "tweet") {
      window.open(`https://twitter.com/intent/tweet?url=${url}&text=${encodeURIComponent(document.title)}`);
    } else if (action === "email") {
      window.open(`mailto:?subject=${encodeURIComponent(document.title)}&body=${encodeURIComponent(url)}`);
    }
  };
  return /* @__PURE__ */ react.createElement("div", {
    className: "claps-share-modal"
  }, /* @__PURE__ */ react.createElement("div", {
    className: "claps-share-content"
  }, /* @__PURE__ */ react.createElement("header", {
    className: "claps-share-header"
  }, /* @__PURE__ */ react.createElement("h3", null, "Share this page"), /* @__PURE__ */ react.createElement("button", {
    type: "button",
    className: "claps-share-close",
    onClick: onClose
  }, /* @__PURE__ */ react.createElement("svg", {
    width: "22",
    height: "22",
    "aria-label": "cancel"
  }, /* @__PURE__ */ react.createElement("use", {
    href: "#icon-x"
  })))), /* @__PURE__ */ react.createElement("div", {
    className: "claps-share-buttons"
  }, /* @__PURE__ */ react.createElement("button", {
    type: "button",
    className: "claps-share-button",
    onClick: () => onAction("clipboard")
  }, /* @__PURE__ */ react.createElement("span", {
    className: "claps-share-button-icon"
  }, /* @__PURE__ */ react.createElement("svg", {
    width: "26",
    height: "26",
    "aria-label": "clipboard"
  }, /* @__PURE__ */ react.createElement("use", {
    href: "#icon-clipboard"
  }))), /* @__PURE__ */ react.createElement("span", null, "Copy link")), /* @__PURE__ */ react.createElement("button", {
    type: "button",
    className: "claps-share-button",
    onClick: () => onAction("tweet")
  }, /* @__PURE__ */ react.createElement("span", {
    className: "claps-share-button-icon"
  }, /* @__PURE__ */ react.createElement("svg", {
    width: "26",
    height: "26",
    "aria-label": "twitter"
  }, /* @__PURE__ */ react.createElement("use", {
    href: "#icon-twitter"
  }))), /* @__PURE__ */ react.createElement("span", null, "Tweet")), /* @__PURE__ */ react.createElement("button", {
    type: "button",
    className: "claps-share-button",
    onClick: () => onAction("email")
  }, /* @__PURE__ */ react.createElement("span", {
    className: "claps-share-button-icon"
  }, /* @__PURE__ */ react.createElement("svg", {
    width: "26",
    height: "26",
    "aria-label": "email"
  }, /* @__PURE__ */ react.createElement("use", {
    href: "#icon-email"
  }))), /* @__PURE__ */ react.createElement("span", null, "Send email")))));
}

// components/claps/claps.tsx
var REACTION_DURATION = 600;
function Claps({
  key,
  fixed,
  replyUrl,
  replyCount,
  apiPath = `/api/claps`,
  iconClap,
  iconReply,
  shareButton = true
}) {
  const [ready, setReady] = (0,react.useState)(false);
  const [showShare, setShowShare] = (0,react.useState)(false);
  const [reaction, setReaction] = (0,react.useState)("" /* default */);
  const [cacheCount, setCacheCount] = (0,react.useState)(0);
  const [data, setData] = (0,react.useState)({
    totalScore: 0,
    userScore: 0,
    totalUsers: 0,
    maxClaps: 0
  });
  const setReactionAnim = (reaction2) => {
    setReaction(reaction2);
    return setTimeout(() => {
      setReaction("" /* default */);
    }, REACTION_DURATION);
  };
  const onClapSaving = (0,react.useCallback)((0,lodash.debounce)(async (score, data2) => {
    try {
      if (data2.userScore >= data2.maxClaps) {
        return setReactionAnim("headShake animated" /* no */);
      }
      const response = await fetch(apiPath, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ score, key })
      });
      if (!response.ok) {
        return setReactionAnim("headShake animated" /* no */);
      }
      const newData = await response.json();
      setData(newData);
      setReactionAnim("heartBeat animated" /* yes */);
    } catch (error) {
      console.error(error);
    } finally {
      setCacheCount(0);
    }
  }, 1e3), []);
  const onClap = () => {
    const value = cacheCount === data.maxClaps ? cacheCount : cacheCount + 1;
    setCacheCount(value);
    return onClapSaving(value, data);
  };
  const getData = async () => {
    try {
      const response = await fetch(apiPath, {
        method: "GET"
      });
      if (!response.ok)
        return;
      const data2 = await response.json();
      setData(data2);
    } catch (error) {
      console.log(error);
    } finally {
      setReady(true);
    }
  };
  (0,react.useEffect)(() => {
    getData();
  }, []);
  return /* @__PURE__ */ react.createElement("div", {
    className: "claps-root",
    style: {
      "--animate-duration": `${REACTION_DURATION}ms`
    }
  }, /* @__PURE__ */ react.createElement(Icons, null), showShare && /* @__PURE__ */ react.createElement(Share, {
    onClose: () => setShowShare(false)
  }), /* @__PURE__ */ react.createElement("div", {
    className: classnames("claps-body", {
      [`claps-fixed claps-fixed-${fixed}`]: fixed
    })
  }, /* @__PURE__ */ react.createElement("div", {
    className: classnames("claps-buttons", reaction)
  }, /* @__PURE__ */ react.createElement("button", {
    disabled: !ready,
    title: `${data.totalUsers} users clapped`,
    "aria-label": "Clap",
    onClick: onClap,
    className: classnames("claps-button claps-button-clap", {
      "claps-button-cache": cacheCount,
      clapped: data.userScore
    })
  }, iconClap || /* @__PURE__ */ react.createElement("svg", {
    width: "26",
    height: "26",
    "aria-label": "clap",
    style: { marginTop: -1 }
  }, data.userScore ? /* @__PURE__ */ react.createElement("use", {
    href: "#icon-claps-fill"
  }) : /* @__PURE__ */ react.createElement("use", {
    href: "#icon-claps"
  })), ready && /* @__PURE__ */ react.createElement("span", {
    className: "claps-button-text"
  }, data.totalScore + cacheCount)), replyUrl && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("span", {
    className: "claps-divider"
  }), /* @__PURE__ */ react.createElement("a", {
    href: replyUrl,
    rel: "noopener noreferrer",
    target: "_blank",
    className: "claps-button claps-button-reply"
  }, iconReply || /* @__PURE__ */ react.createElement("svg", {
    width: "22",
    height: "22",
    "aria-label": "reply"
  }, /* @__PURE__ */ react.createElement("use", {
    href: "#icon-reply"
  })), replyCount && /* @__PURE__ */ react.createElement("span", {
    className: "claps-button-text"
  }, replyCount))), shareButton && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("span", {
    className: "claps-divider"
  }), /* @__PURE__ */ react.createElement("button", {
    type: "button",
    className: "claps-button",
    onClick: () => {
      setShowShare(true);
    }
  }, /* @__PURE__ */ react.createElement("svg", {
    width: "20",
    height: "20",
    "aria-label": "share"
  }, /* @__PURE__ */ react.createElement("use", {
    href: "#icon-dots"
  })))))));
}


// EXTERNAL MODULE: ./slices/index.js + 7 modules
var slices = __webpack_require__(2975);
// EXTERNAL MODULE: ./src/components/Layout.js + 4 modules
var Layout = __webpack_require__(1128);
// EXTERNAL MODULE: ./src/components/Bounded.js
var Bounded = __webpack_require__(2236);
// EXTERNAL MODULE: ./src/components/Heading.js
var Heading = __webpack_require__(1839);
// EXTERNAL MODULE: ./src/components/HorizontalDivider.js
var HorizontalDivider = __webpack_require__(1685);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(2010);
;// CONCATENATED MODULE: ./src/pages/articles/[uid].js













const dateFormatter = new Intl.DateTimeFormat("pt-BR", {
    month: "short",
    day: "numeric",
    year: "numeric"
});
const LatestArticle = (param)=>{
    let { article  } = param;
    const date = helpers_dist/* asDate */.qF(article.data.publishDate || article.first_publication_date);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "mb-3 text-3xl font-semibold tracking-tighter text-slate-800 dark:text-[#f5f4f5] md:text-4xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* PrismicLink */.wK, {
                    document: article,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* PrismicText */.Kv, {
                        field: article.data.title
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-serif italic tracking-tighter text-slate-500 dark:text-[#f5f4f5]",
                children: dateFormatter.format(date)
            })
        ]
    });
};
const Article = (param)=>{
    let { article , latestArticles , navigation , settings  } = param;
    const [isMounted, setIsMounted] = (0,react.useState)(false);
    const { theme  } = (0,index_module/* useTheme */.F)();
    (0,react.useEffect)(()=>{
        setIsMounted(true);
    }, []);
    if (!isMounted) return null;
    const date = helpers_dist/* asDate */.qF(article.data.publishDate || article.first_publication_date);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
        withHeaderDivider: false,
        withProfile: false,
        withSignUpForm: true,
        withLogo: true,
        navigation: navigation,
        settings: settings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            helpers_dist/* asText */.Sz(article.data.title),
                            " |",
                            " ",
                            helpers_dist/* asText */.Sz(settings.data.name)
                        ]
                    }),
                    theme === "dark" && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://cdn.rawgit.com/Killercodes/281792c423a4fe5544d9a8d36a4430f2/raw/36c2eb3e0c44133880485a143717bda9d180f2c1/GistDarkCode.css",
                        rel: "stylesheet",
                        type: "text/css"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bounded/* Bounded */.g, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* PrismicLink */.wK, {
                    href: "/",
                    className: "font-semibold tracking-tight text-slate-400 dark:text-[#f5f4f5]",
                    children: "← Voltar para artigos"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bounded/* Bounded */.g, {
                        className: "pb-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "mb-3 text-3xl font-semibold tracking-tighter text-slate-800 dark:text-[#f5f4f5] md:text-4xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* PrismicText */.Kv, {
                                    field: article.data.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-serif italic tracking-tighter text-slate-500 dark:text-[#f5f4f5]",
                                children: dateFormatter.format(date)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SliceZone */.pv, {
                        slices: article.data.slices,
                        components: slices/* components */.wx
                    })
                ]
            }),
            latestArticles.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Bounded/* Bounded */.g, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 justify-items-center gap-16 md:gap-24",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalDivider/* HorizontalDivider */.E, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                                    size: "2xl",
                                    className: "mb-10",
                                    children: "\xdaltimos Artigos"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "grid grid-cols-1 gap-12",
                                    children: latestArticles.map((article)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LatestArticle, {
                                            article: article
                                        }, article.id))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Claps, {
                fixed: "left"
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _uid_ = (Article);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [617,662,756,67,128,774,888,179], function() { return __webpack_exec__(628); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);